import { setup as setupLocatorUI } from '@locator/runtime';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';

import { StrictMode } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { initMSW } from './mocks';
import { routeTree } from './routeTree.gen';
import { TooltipProvider } from './shared/components/shadcn/tooltip';
import { queryClient } from './shared/query-client';
import './shared/styles/index.css';
import './shared/utils/instrument';
import { viteEnvSchema } from './shared/utils/vite-env';

// Env 스키마 검증
viteEnvSchema.parse(import.meta.env);

// develop환경에선 locatorUI 활성화
if (process.env.NODE_ENV === 'development') {
  setupLocatorUI();
}

// 새로운 router instance 생성
const router = createRouter({ routeTree });

const rootElement = document.getElementById('root')!;
let appRoot: Root | undefined;
let mswInitPromise: Promise<unknown> | undefined;

async function bootstrap() {
  mswInitPromise ??= initMSW();
  await mswInitPromise;

  appRoot ??= createRoot(rootElement);
  appRoot.render(
    <StrictMode>
      <TooltipProvider delayDuration={0}>
        <QueryClientProvider client={queryClient}>
          <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <RouterProvider router={router} />
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </TooltipProvider>
    </StrictMode>,
  );
}

void bootstrap();
